import { TextFieldHelper } from "@goodgamestudios/core";
import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TablesAchievementProperties } from "./Poker2TablesAchievementProperties";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2TableAchievement extends Poker2Dialog {
    public static NAME: string = "Poker2TableAchievement";
    private MAX_ITEM_WIDTH: number = 60;
    private MAX_ITEM_HEIGHT: number = 60;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();
    }
    protected applyProperties(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(16, this.achievementDialog.txt_title, this.achievementProperties.achievementName);
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.achievementDialog.txt_copy, Poker2Model.languageData.getTextById("dialog_achievement_table_copy", [this.achievementProperties.achievementRank]), 3);
        this.drawAchievement();
    }
    private drawAchievement(): void {

        var mcClass: any = getDefinitionByName(this.achievementProperties.achievement.getVisClassName()) as any;
        var achievementMC: MovieClip = new mcClass();
        var bounds: Rectangle = achievementMC.getBounds(null);

        var scaleFactor: number = (this.MAX_ITEM_WIDTH / bounds.width);
        if ((bounds.height * scaleFactor) > this.MAX_ITEM_HEIGHT)
            scaleFactor = (this.MAX_ITEM_HEIGHT / bounds.height);

        achievementMC.scaleX = achievementMC.scaleY = scaleFactor;
        achievementMC.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        achievementMC.y = - ((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

        while (this.achievementDialog.mc_holder.numChildren > 0)
            this.achievementDialog.mc_holder.removeChildAt(0);
        this.achievementDialog.mc_holder.addChild(achievementMC);
    }
    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.achievementDialog.btn_close:
                this.hide();
                break;
        }
    }

    protected get achievementProperties(): Poker2TablesAchievementProperties {
        return this.properties as Poker2TablesAchievementProperties;
    }

    protected get achievementDialog(): Library.PokerInterface.OnTableAchievement {
        return this.disp as Library.PokerInterface.OnTableAchievement;
    }
}
